import { render, staticRenderFns } from "./actIntro.vue?vue&type=template&id=30024cab&scoped=true"
import script from "./actIntro.vue?vue&type=script&lang=js"
export * from "./actIntro.vue?vue&type=script&lang=js"
import style0 from "./actIntro.vue?vue&type=style&index=0&id=30024cab&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30024cab",
  null
  
)

export default component.exports